import React from "react";

const Chapter20 = () => {
    return (
        <div className="page-padd">
            <center>
                <iframe
                    src="./chapter20.html"
                    title="HTML File"
                    width="100%"
                    height="800px"
                    style={{ border: "none" }}
                />
            </center>
        </div>
    );
}

export default Chapter20;